import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Build hash buster: the prior deploy's entry bundle (index-B0asUZZR.js) was a
// corrupted blob that 500'd on Cloudflare's edge. Pages dedupes assets by content
// hash, so a byte-identical rebuild reused the bad blob. This side-effecting marker
// survives minification, forcing a new entry hash and a fresh upload. The value is
// referenced via the global so it can't be tree-shaken away.
;(window as unknown as Record<string, string>).__BUILD_MARKER__ = 'cf-asset-rebuild-2026-05-28'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
